import './App.css';
import Routes from './route/router';
import './assets/css/styles.css';
// import './assets/css/intro-about.css';
import { useEffect } from 'react';

function App() {
  // Performance monito

  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
